export default __webpack_public_path__ + "static/media/home.7af9c431.jpg";